// extracted by mini-css-extract-plugin
export default {"container":"ReportPage_container__SKxe+","pageTitle":"ReportPage_pageTitle__cZsh7"};